import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimes, FaSave, FaStore, FaCity, FaPhoneAlt, FaEnvelope, FaUserShield, FaMapMarkedAlt, FaToggleOn } from "react-icons/fa";

import axios from "axios";
import PageCreateHeader from "../../components/PageCreateHeader";

const OutletForm = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  
  useEffect(() => {
    const role = localStorage.getItem("role");
    
    if (role !== "owner") {
      setShowAccessDenied(true);
    }
  
    fetchManagers(); // jalankan fetchManagers agar datanya diambil saat komponen dimuat
  }, []);
  const [formData, setFormData] = useState({
    name: "",
    kota: "",
    phone: "",
    email: "",
    status: "active",
    manager_id: "",
    address: "",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  });

  const [managers, setManagers] = useState([]);
  const [outlets, setOutlets] = useState([]);

  const fetchManagers = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token tidak ditemukan.");
        return;
      }
  
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log("Respon API Manager:", response);
  
      const data = response?.data?.data || [];
      console.log("Data Manager:", data);
  
      // Pastikan data memiliki full_name
      const managersData = Array.isArray(data)
        ? data.map((manager) => ({
            id: manager.id,
            full_name: manager.full_name || "Nama Tidak Tersedia",
          }))
        : [];
  
      setManagers(managersData);
    } catch (error) {
      console.error("Error saat fetch data manager:", error);
      if (error.response) {
        console.error("Respon error:", error.response);
      }
    }
  };
  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
        );
        setOutlets(response.data.data || []);
      } catch (error) {
        console.error("Error saat fetch data outlet:", error);
      }
    };

    fetchOutlets();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      console.log("Mengirim data:", formData);
  
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!token) {
        alert("Token tidak ditemukan. Silakan login ulang.");
        return;
      }
  
      // Konversi manager_id ke integer
      const payload = {
        ...formData,
        manager_id: parseInt(formData.manager_id, 10),
      };
  
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
  
      console.log("Respon API:", response);
  
      if (response.status === 200 || response.status === 201) {
        const newOutlet = response.data.data;
        setOutlets((prevOutlets) => [...prevOutlets, newOutlet]);
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
          navigate("/enterprise/outlet");
        }, 2000); // Pop-up muncul 2 detik lalu redirect

      } else {
        console.error("Respon tidak sesuai:", response);
        alert("Gagal membuat outlet. Silakan coba lagi.");
      }
    } catch (error) {
      console.error("Error saat membuat outlet:", error);
  
      if (error.response) {
        console.error("Respon error:", error.response);
        alert(`Gagal: ${error.response.status} - ${error.response.data.message || "Kesalahan Server"}`);
      } else if (error.request) {
        console.error("Tidak ada respon dari server:", error.request);
        alert("Tidak ada respon dari server. Periksa koneksi internet atau coba lagi nanti.");
      } else {
        console.error("Error lainnya:", error.message);
        alert("Terjadi kesalahan. Silakan coba lagi.");
      }
    }
  };
  

  return (
    <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0">
      <PageCreateHeader
        icon={FaStore}
        title="Buat Outlet"
        description="Isi form untuk menambah data outlet baru"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Outlet", to: "/enterprise/outlet" },
          { label: "Buat Outlet" },
        ]}
      />

      <div className="bg-white p-5 rounded-2xl shadow-2xl w-full max-w-none border border-gray-100">
        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6 w-full">
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaStore className="mr-2 text-blue-500"/> Nama Outlet
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaCity className="mr-2 text-blue-500"/> Kota
            </label>
            <input type="text" name="kota" value={formData.kota} onChange={handleChange}
                   className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300" required/>
          </div>
          
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaPhoneAlt className="mr-2 text-blue-500"/> Telepon
            </label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange}
                   className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300" required/>
          </div>
          
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaEnvelope className="mr-2 text-blue-500"/> Email
            </label>
            <input type="email" name="email" value={formData.email} onChange={handleChange}
                   className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300" required/>
          </div>
          
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaToggleOn className="mr-2 text-blue-500"/> Status
            </label>
            <select name="status" value={formData.status} onChange={handleChange}
                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300" required>
              <option value="active">Active</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          
          <div>
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaUserShield className="mr-2 text-blue-500"/> Pilih Manager
            </label>
            <select
              name="manager_id"
              value={formData.manager_id}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300"
            >
              <option value="">-- Pilih Manager --</option>
              {managers.length > 0 ? (
                managers.map((manager) => (
                  <option key={manager.id} value=""> 
                    {manager.full_name}
                  </option>
                ))
              ) : (
                <option disabled>Data manager tidak tersedia</option>
              )}
            </select>
          </div>
          
          <div className="w-full">
            <label className="flex items-center text-gray-700 mb-2 font-medium">
              <FaMapMarkedAlt className="mr-2 text-blue-500"/> Alamat
            </label>
            <textarea name="address" value={formData.address} onChange={handleChange}
                      className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-300"
                      rows={3}></textarea>
          </div>
          
          <div className="w-full flex justify-end space-x-4 mt-4">
            <button
              type="button"
              onClick={() => navigate("/enterprise/outlet")}
              className="flex items-center bg-gray-500 text-white px-5 py-3 rounded-xl hover:bg-gray-600 transition duration-200"
            >
              <FaTimes className="mr-2"/> Batal
            </button>
            <button
              type="submit"
              className="flex items-center bg-blue-600 text-white px-5 py-3 rounded-xl hover:bg-blue-700 transition duration-200"
            >
              <FaSave className="mr-2"/> Simpan
            </button>
          </div>
        </form>
      </div>

      {showSuccessModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-xl shadow-2xl p-6 w-96 text-center animate-bounceIn">
            <h2 className="text-2xl font-bold text-green-600 mb-2">✅ Berhasil!</h2>
            <p className="text-gray-700">Outlet baru berhasil ditambahkan.</p>
          </div>
        </div>
      )}
      
      {showAccessDenied && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-2xl w-96 text-center">
            <h2 className="text-2xl font-bold mb-3 text-red-600">🚫 Akses Ditolak</h2>
            <p className="text-gray-600 mb-5">Anda tidak memiliki hak akses untuk memasuki halaman ini.</p>
            <button
              onClick={() => navigate("/dashboard")}
              className="w-full bg-red-500 text-white py-2 rounded-xl hover:bg-red-600 transition duration-200"
            >
              Kembali ke Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OutletForm;
